exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.company-nav-card{position:relative;width:246px;min-height:71px;background-color:#222;cursor:pointer;color:#8b8b8b}.company-nav-card.is-vendor{padding-left:20px;width:226px}.company-nav-card:hover .menu-selector{display:block}.company-nav-card.selected{color:#fff;background-color:#3e3e3e}.company-nav-card .expand-contract{position:absolute;width:10px;height:14px;font-size:12px;top:15px;left:10px}.company-nav-card .info-line{position:relative;display:flex;margin-left:25px;margin-top:16px;min-height:30px;width:179px}.company-nav-card .info-line .company-info{display:flex;flex-direction:column;width:156px}.company-nav-card .info-line .company-info .company-title{width:156px;font-family:Open Sans,sans-serif;font-weight:700;font-size:13px;letter-spacing:0}.company-nav-card .info-line .company-info .company-address{font-family:Open Sans,sans-serif;font-weight:400;font-size:11px;letter-spacing:0}.company-nav-card .separator-line{margin-left:25px;width:179px;border:none;border-bottom:1px solid #383838}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/CompaniesContainer/CompaniesNav/CompanyNavCard/CompanyNavCard.scss
// module id = 1717
// module chunks = 0